module.exports = __webpack_public_path__ + "img/3clubs.d1aa6f32.jpg";